import { useEffect, useRef, useState } from 'react';
import { Table, Input, Button, Select, Form, InputNumber, Radio, Space, Tag, Row, Col, DatePicker } from 'antd';
import EventEmitter from '../utils/eventEmitter';
import { ActionColumn } from '../utils/tableMockData';
import dayjs from 'dayjs';



const EditableCell = ({ editing, dataIndex, title, form, inputType, options, record, index, children, ...restProps }) => {
  const onChange = (option, form, dataIndex) => EventEmitter.dispatch('selected', {option, form, key:record.key, dataIndex});

  const inputNode = inputType === 'select' ? <Select style={{width: '140px'}} options={options} fieldNames={dataIndex} onChange={(value, option)=>onChange(option, form, dataIndex)}/> :
    inputType === 'date' ? 
    <DatePicker />: 
    inputType === 'number' ?
    <InputNumber />
    : <Input />;

    return (
    <td {...restProps}>
      {editing ? (
        <Form.Item name={dataIndex} className='m-0' >
          {inputNode}
        </Form.Item>
      ) : (
        // children
        <>{
            
            inputType === 'select' ?
            form.getFieldValue(record.position_id) : 
            dataIndex === 'start_date' ?
            new Date(record.start_date).toLocaleDateString() :
            dataIndex === 'end_date' ?
            new Date(record.end_date).toLocaleDateString() :
            // <DatePicker readOnly inputReadOnly disabled value={form.getFieldValue(dataIndex)}/> :
            // form.getFieldValue(dataIndex) !== undefined && new Date(form.getFieldValue(dataIndex)).toLocaleDateString() :
            children 
          }</>
      )}
    </td>
  );
};


 
const BudgetTable = ({name, budget, budgets, dataSource, period, setEntries, columns, positions, taxes, status }) => {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;

  const edit = async (record) => {
      form.setFieldsValue({ ...record })
      setEditingKey(record.key)
    
  };

  const cancel = () => {
    setEditingKey('')
  }

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key)
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row })
        console.log(newData)
        setEntries(newData)
        setEditingKey('')
      }
    } catch (err) {
      console.log('Validate Failed:', err)
    }
  }
  
  const addEntry = () => {
    let journalEntries_ = [...dataSource]
    let entryObj = {
      key: dataSource.length + 1,
      position_id: '',
      start_date: period.length > 0 ? period[0] : '',
      end_date: period.length > 0 ? period[1] : '',
      practical_amount: 0,
      planned_amount: 0
    }
    if (budget) entryObj['budget_id'] = '';
    form.setFieldsValue({ ...entryObj });
    journalEntries_.push(entryObj)
    
    setEntries(journalEntries_);
    setEditingKey(dataSource.length + 1)
  }



  const removeEntry = (key) => {
    let entries = dataSource.filter((item) => item.key !== key)
    // entries.map((entryObj, index) => (entryObj['key'] = index))
    setEntries(entries);
  }

  
  columns[columns.length - 1]['render'] = (_, record) =>
    ActionColumn(_, record, isEditing, save, edit, cancel, removeEntry)

  if (status !== 'draft')
    delete columns[columns.length - 1]['render']


  useEffect(() => { 
    EventEmitter.subscribe('selected', data=> {
      const { option, form, key, dataIndex } = data;
      const { label, value } = option;
      form.setFieldValue(value, option.label);
    });
    return () => { 
      EventEmitter.unsubscribe('selected');
    }
  },[]);

  useEffect(() => {
    if (dataSource.length > 0) {
      dataSource.forEach((transaction) => {
        let position = positions.find((position) => position._id === transaction.position_id);
        form.setFieldValue(`${position._id}`, `${position.name}`)
      })
    }
  },[]);


  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
    ...col,
    onCell: (record) => ({
      record,
      editable: col.editable,
      dataIndex: col.dataIndex,
      title: col.title,
      form: form,
      // selectedValue: selectedValue,
      inputType: (col.dataIndex === 'position_id' || col.dataIndex === 'budget_id') ? 'select' : 
      (col.dataIndex.includes('date')) ? 'date' : (col.dataIndex.includes('amount')) ? 'number' : 'text',
      options: col.dataIndex === 'position_id' && 
        positions.map(positon => ({value: positon._id, label: `${positon.name}`})) || 
      col.dataIndex === 'budget_id' && 
        budgets.map(budget => ({value: budget._id, label: budget.name})),
      editing: isEditing(record),
    }),
  }});

  return (
    <Form 
        form={form} 
        component={false} 
        initialValues={{debit: 0, credit: 0}}
        labelAlign='right'
        labelCol={{span: 15}}
      >
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        dataSource={dataSource}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={false}
      />
      {status === 'draft' && <Button onClick={addEntry}>Add Entry</Button>}
    </Form>
  );
};

export default BudgetTable;
